import LayoutBackend from '@/layouts/variations/Backend.vue';
import { checkAuth, requireAuth } from '@/router/helpers.js';

const Main = () => /* webpackChunkName: "group-event" */ import(`@/views/Events/Main/Main.vue`);

// TODO: 상시 이벤트
const TwitterEnroll = () => /* webpackChunkName: "group-event" */ import(`@/views/Events/Twitter/Twitter.vue`);
const GachaMain = () => /* webpackChunkName: "group-event" */ import(`@/views/Events/Gacha/Main.vue`);
const Roulette = () => import(`@/views/Events/Roulette/Roulette.vue`);
const Referral = () => import(`@/views/Events/2025/Referral/Referral.vue`);
// TODO: 상시 이벤트

const AirDrop = () => import(`@/views/Events/2024/Airdrop/Airdrop.vue`);
const Christmas = () => import(`@/views/Events/2024/Christmas/Christmas.vue`);
const NewYear = () => import(`@/views/Events/2025/NewYear/NewYear.vue`);
const January = () => import(`@/views/Events/2025/January/Page.vue`);
const LunarNewYear = () => import(`@/views/Events/2025/LunarNewYear/Page.vue`);
const Valentine = () => import(`@/views/Events/2025/Valentine/Page.vue`);
const Barbeque = () => import(`@/views/Events/2025/Barbeque/Page.vue`);
const Flower = () => import(`@/views/Events/2025/Spring/Page.vue`);
const Growing = () => import(`@/views/Events/2025/Growing/Page.vue`);
const Departure = () => import(`@/views/Events/2025/Departure/Departure.vue`);
const Dalgona = () => import(`@/views/Events/2025/Dalgona/Page.vue`);
const IceCream = () => import(`@/views/Events/2025/IceCream/Page.vue`);
const Environment = () => import(`@/views/Events/2025/Environment/Page.vue`);
const NewYear2026 = () => import(`@/views/Events/2026/NewYear/Page.vue`);

const events = [
  {
    path: '/event',
    name: 'Event',
    redirect: '/event/home',
    component: LayoutBackend,
    beforeEnter: checkAuth(),
    children: [
      {
        path: 'home',
        name: 'EventHome',
        component: Main,
      },
      // TODO: 상시 이벤트
      {
        path: 'roulette',
        name: 'Roulette',
        component: Roulette,
        beforeEnter: requireAuth(),
      },
      {
        path: 'twitter',
        name: 'Twitter',
        component: TwitterEnroll,
      },
      {
        path: 'gacha',
        name: 'Gacha',
        component: GachaMain,
        beforeEnter: requireAuth(),
      },
      // TODO: 상시 이벤트
      {
        path: 'airdrop',
        name: 'AirDrop',
        component: AirDrop,
        // beforeEnter: requireAuth(),
      },
      {
        path: 'referral',
        name: 'Referral',
        component: Referral,
        beforeEnter: requireAuth(),
      },
      // TODO: 상시 이벤트

      {
        path: 'christmas',
        name: 'Christmas',
        component: Christmas,
        beforeEnter: requireAuth(),
      },
      {
        path: 'newyear',
        name: 'NewYear',
        component: NewYear,
        beforeEnter: requireAuth(),
      },
      {
        path: 'january',
        name: 'January',
        component: January,
        beforeEnter: requireAuth(),
      },
      {
        path: 'lunar-new-year',
        name: 'LunarNewYear',
        component: LunarNewYear,
        beforeEnter: requireAuth(),
      },
      {
        path: 'valentine',
        name: 'Valentine',
        component: Valentine,
        beforeEnter: requireAuth(),
      },
      {
        path: 'kick-off',
        name: 'Kickoff',
        component: Departure,
        beforeEnter: requireAuth(),
      },
      {
        path: 'barbeque',
        name: 'Barbeque',
        component: Barbeque,
        beforeEnter: requireAuth(),
      },
      {
        path: 'flower',
        name: 'Flower',
        component: Flower,
        beforeEnter: requireAuth(),
      },
      {
        path: 'growing',
        name: 'Growing',
        component: Growing,
        beforeEnter: requireAuth(),
      },
      {
        path: 'dalgona',
        name: 'Dalgona',
        component: Dalgona,
        beforeEnter: requireAuth(),
      },
      {
        path: 'ice-cream',
        name: 'IceCream',
        component: IceCream,
        beforeEnter: requireAuth(),
      },
      {
        path: 'environment',
        name: 'Environment',
        component: Environment,
        beforeEnter: requireAuth(),
      },
      {
        path: 'newyear-2026',
        name: 'NewYear2026',
        component: NewYear2026,
        beforeEnter: requireAuth(),
      },
    ],
  },
];

export { events };
